import { render, staticRenderFns } from "./bfollow.vue?vue&type=template&id=3c478ab0&scoped=true&"
import script from "./bfollow.vue?vue&type=script&lang=js&"
export * from "./bfollow.vue?vue&type=script&lang=js&"
import style0 from "./bfollow.vue?vue&type=style&index=0&id=3c478ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c478ab0",
  null
  
)

export default component.exports